import { css } from '@emotion/react';

export const candidateContentStyles = css`
  display: flex;
  justify-content: space-between;
  margin: 28px 0 0;
`;
